import { iosPayUrl } from '../../config/net'
import loadingTools from '../../tools/loading'
import device from '@/tools/device'
/* eslint-disable */

export const canSelectPay = function () {
  let timeoutHandler = null
  return new Promise((resolve) => {
    try {
      // 300ms未响应则中断
      timeoutHandler = setTimeout(function () {
        resolve([])
        timeoutHandler = null
      }, 250)
      let cb = function (res) {
        if (!timeoutHandler) return
        clearTimeout(timeoutHandler)
        resolve(res)
      }
      $fe_bridge.account.supportList(cb)
    }
    catch (e) {
      resolve([])
    }
  })
}

// alipay
export const alipay = function (msg) {
  return new Promise((resolve, reject) => {
    try {
      $fe_bridge.pay.alipay.create(msg, function (result) {
        // TODO 针对IOS做的临时支付处理
        if (device.ios) {
          if (typeof result !== 'object') {
            try {
              result = decodeURIComponent(result)
              result = JSON.parse(result)
            } catch (e) {
              console.log(e)
              console.log(e.message)
            }
          }
          if (('content' in result) && result.content !== '取消支付') {
            resolve(result)
          }
        } else {
          resolve(result)
        }
      })
    } catch (e) {
      console.log(e)
      console.log(e.message)
      reject(e)
    }
  })
}

// wechat
export const wechatPay = function (msg) {
  return new Promise((resolve, reject) => {
    try {
      $fe_bridge.pay.wechat.create(msg, function (result) {
        // TODO 针对IOS做的临时支付处理
        if (device.ios) {
          if (typeof result !== 'object') {
            try {
              result = decodeURIComponent(result)
              result = JSON.parse(result)
            } catch (e) {
              console.log(e)
              console.log(e.message)
            }
          }
          if (('content' in result) && result.content !== '取消支付') {
            resolve(result)
          }
        } else {
          resolve(result)
        }
      })
    } catch (e) {
      console.log(e)
      console.log(e.message)
      reject(e)
    }
  })
}

// ios内购
/**
 *
 * @param iap { order: order.Data, store: product.store }
 * @returns {Promise}
 */
export const iosPay = function (orderModel, appleStore) {
  return new Promise((resolve, reject) => {
    let loading = loadingTools(60 * 1000)
    try {
      loading.loading()
      $fe_bridge.session.send('POST', iosPayUrl, orderModel, function (order) {
        if (order.Status == 0 && order.ErrCode == 0) {
          var iap = {order: order.Data, store: appleStore.store}
          $fe_bridge.pay.inAppPurchase.create(iap, function (result) {
            loading.hide()
            resolve({result, price: order.orderMoney})
          })
        } else {
          loading.hide()
          reject({errMsg: order.ErrMsg, price: order.orderMoney || ''})
        }
      })
    } catch (e) {
      loading.hide()
      reject({price: ''})
    }
  })
}



// WEBPACK FOOTER //
// ./src/model/pay/pay-bridge.js